const genders = ['male', 'female', 'other'];

enum ContactType {
    Company = 'company',
    Individual = 'individual',
}

type ManualActivityType =
    | 'sms'
    | 'email'
    | 'phone_call'
    | 'note'
    | 'meeting'
    | 'completed_task'
    | 'volunteer_activity';

type ContactActivityConstant = {
    value: ManualActivityType;
    label: string;
};

const requiresSubject = new Set([
    'sms',
    'email',
    'phone_call',
    'meeting',
    'completed_task',
    'volunteer_activity',
]);

const CONTACT_ACTIVITIES = [
    { value: 'sms', label: 'SMS' },
    { value: 'note', label: 'Note' },
    { value: 'email', label: 'Email' },
    { value: 'phone_call', label: 'Phone call' },
    { value: 'meeting', label: 'Meeting' },
    { value: 'completed_task', label: 'Completed task' },
    { value: 'volunteer_activity', label: 'Volunteer activity' },
] as ContactActivityConstant[];

export type { ManualActivityType, ContactActivityConstant };

export { genders, CONTACT_ACTIVITIES, requiresSubject, ContactType };
